import { render } from "./NewsSection.vue?vue&type=template&id=89255800&scoped=true"
import script from "./NewsSection.vue?vue&type=script&lang=js"
export * from "./NewsSection.vue?vue&type=script&lang=js"

import "./NewsSection.vue?vue&type=style&index=0&id=89255800&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89255800"]])

export default __exports__